import React, { useState } from 'react';
import { LayoutSingleColumn, NamedLink, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { useIntl, FormattedMessage } from 'react-intl';
import css from './FaqPage.module.css';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import faqHelp from '../../assets/faq-help.png';
import faqHero from '../../assets/FAQ.gif';


function FaqPage() {
    const intl = useIntl();
    // Track open item per section: { [sectionId]: index | null }
    const [openMap, setOpenMap] = useState({});
    // Active tab id (section id)
    const [activeTab, setActiveTab] = useState('getting-started');

    const toggleItem = (sectionId, index) => {
        setOpenMap(prev => {
            const current = prev[sectionId];
            const nextIndex = current === index ? null : index;
            return { ...prev, [sectionId]: nextIndex };
        });
    };
    const isArabic = intl.locale.toLowerCase().startsWith('ar');    
    const sections = [
        {
            id: 'getting-started',
            icon: <IconCard type="learning" />,
            tabTitle: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.tabTitle' }),
            title: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.title' }),
            description: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.description' }),
            faqs: [
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.q1' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.a1' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.q2' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.a2' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.q3' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.a3' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.q4' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.a4' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.q5' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.gettingStarted.a5' }),
                },
            ],
        },
        {
            id: 'lessons',
            icon: <IconCard type="lessons" />,
            tabTitle: intl.formatMessage({ id: 'FaqPage.section.lessons.tabTitle' }),
            title: intl.formatMessage({ id: 'FaqPage.section.lessons.title' }),
            description: intl.formatMessage({ id: 'FaqPage.section.lessons.description' }),
            faqs: [
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.lessons.q1' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.lessons.a1' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.lessons.q2' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.lessons.a2' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.lessons.q3' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.lessons.a3' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.lessons.q4' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.lessons.a4' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.lessons.q5' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.lessons.a5' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.lessons.q6' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.lessons.a6' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.lessons.q7' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.lessons.a7' }),
                },
            ],
        },
        {
            id: 'payment-wallet',
            icon: <IconCard type="paymentwallet" />,
            tabTitle: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.tabTitle' }),
            title: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.title' }),
            description: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.description' }),
            faqs: [
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.q1' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.a1' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.q2' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.a2' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.q3' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.a3' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.q4' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.a4' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.q5' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.paymentwallet.a5' }),
                },
            ],
        },
        {
            id: 'tutors',
            icon: <IconCard type="becometutor" />,
            tabTitle: intl.formatMessage({ id: 'FaqPage.section.becometutor.tabTitle' }),
            title: intl.formatMessage({ id: 'FaqPage.section.becometutor.title' }),
            description: intl.formatMessage({ id: 'FaqPage.section.becometutor.description' }),
            faqs: [
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.becometutor.q1' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.becometutor.a1' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.becometutor.q2' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.becometutor.a2' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.becometutor.q3' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.becometutor.a3' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.becometutor.q4' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.becometutor.a4' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.becometutor.q5' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.becometutor.a5' }),
                },
            ],
        },
        {
            id: 'career',
            icon: <IconCard type="careers" />,
            tabTitle: intl.formatMessage({ id: 'FaqPage.section.career.tabTitle' }),
            title: intl.formatMessage({ id: 'FaqPage.section.career.title' }),
            description: intl.formatMessage({ id: 'FaqPage.section.career.description' }),
            faqs: [
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q1' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a1' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q2' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a2' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q3' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a3' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q4' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a4' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q5' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a5' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q6' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a6' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q7' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a7' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q8' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a8' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.career.q9' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.career.a9' }),
                },
            ],
        },
        {
            id: 'parents',
            icon: <IconCard type="parents" />,
            tabTitle: intl.formatMessage({ id: 'FaqPage.section.parents.tabTitle' }),
            title: intl.formatMessage({ id: 'FaqPage.section.parents.title' }),
            description: intl.formatMessage({ id: 'FaqPage.section.parents.description' }),
            faqs: [
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.parents.q1' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.parents.a1' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.parents.q2' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.parents.a2' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.parents.q3' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.parents.a3' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.parents.q4' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.parents.a4' }),
                },
                {
                    q: intl.formatMessage({ id: 'FaqPage.section.parents.q5' }),
                    a: intl.formatMessage({ id: 'FaqPage.section.parents.a5' }),
                },
            ],
        }, 
    ];
    return (
        <Page
            title={intl.formatMessage({
                id: 'FaqPage.title',
            })}
            scrollingDisabled={false}
            referrer="origin">
            <LayoutSingleColumn
                mainColumnClassName={css.layoutWrapperMain}
                topbar={<TopbarContainer />}
                footer={<FooterContainer />}
            >
                <div className={css.faqContainer}>
                    <div className={css.faqMainCover}>
                        <div className={css.faqCoverSection}>
                            <div className={css.faqHeroLeft}>
                                <div className={css.faqBadge}>
                                    <span className={css.faqBadgeText}>
                                        <FormattedMessage id="FaqPage.badge" defaultMessage="Frequently Asked Question" />
                                    </span>
                                </div>
                                <h1 className={css.title}>
                                    <FormattedMessage id="FaqPage.heading" defaultMessage="Everything you need to know about learning Arabic with Arbibi" />
                                </h1>
                                <p className={css.subtitle}>
                                    <FormattedMessage id="FaqPage.subheading" defaultMessage="We’ve gathered the most common questions from parents students, and tutors to make your journey easy and worry- free. Still have questions?  Our support team is here to help anytime." />
                                </p>
                                <div className={css.faqButton}>
                                    <NamedLink
                                        name="CMSPage"
                                        params={{ pageId: isArabic ? 'ar-contact-us' : 'contact-us' }}
                                    >
                                        <FormattedMessage id="FaqPage.button" defaultMessage="Contact us" />
                                    </NamedLink>
                                </div>
                            </div>
                            <div className={css.faqHeroRight}>
                                <img src={faqHero} alt='faq hero' />
                            </div>
                        </div>
                    </div>
                    <div className={css.faqcards}>
                        {/* Tabs */}
                        <div className={css.tabs} role="tablist" aria-label="FAQ sections">
                            {sections.map(s => {
                                const isActive = s.id === activeTab;
                                return (
                                    <button
                                        key={s.id}
                                        type="button"
                                        role="tab"
                                        aria-selected={isActive}
                                        aria-controls={`panel-${s.id}`}
                                        id={`tab-${s.id}`}
                                        className={`${css.tab} ${isActive ? css.tabActive : ''}`}
                                        onClick={() => setActiveTab(s.id)}
                                    >
                                        {s.tabTitle}
                                    </button>
                                );
                            })}
                        </div>

                        {/* Active section card */}
                        {sections
                            .filter(section => section.id === activeTab)
                            .map(section => (
                                <div key={section.id} className={css.faqCard} id={`panel-${section.id}`} role="tabpanel" aria-labelledby={`tab-${section.id}`}>
                                    <div className={css.faqCardLeft}>
                                        <div className={css.faqIcon} aria-hidden="true">{section.icon}</div>
                                        <h2>{section.title}</h2>
                                        <p>{section.description}</p>
                                    </div>
                                    <div className={css.faqCardWrapper}>
                                        <ul>
                                            {section.faqs.map((item, idx) => {
                                                const isOpen = openMap[section.id] === idx;
                                                return (
                                                    <li
                                                        key={`${section.id}-${idx}`}
                                                        className={`${css.faqItem} ${isOpen ? css.expanded : ''}`}
                                                    >
                                                        <button
                                                            type="button"
                                                            className={css.faqItemHeader}
                                                            id={`${section.id}-header-${idx}`}
                                                            aria-expanded={isOpen}
                                                            aria-controls={`${section.id}-panel-${idx}`}
                                                            onClick={() => toggleItem(section.id, idx)}
                                                        >
                                                            <span className={css.faqQuestion}>{item.q}</span>
                                                            <div className={css.faqAction} aria-label="Open">
                                                                <span className={css.plusIcon} aria-hidden={isOpen}>
                                                                    <IconCard type="plusicon" />
                                                                </span>
                                                                <span className={css.minusIcon} aria-hidden={!isOpen}>
                                                                    <IconCard type="minusicon" />
                                                                </span>
                                                            </div>
                                                        </button>
                                                        <div
                                                            id={`${section.id}-panel-${idx}`}
                                                            className={css.faqAnswer}
                                                            role="region"
                                                            aria-labelledby={`${section.id}-header-${idx}`}
                                                            style={{ display: isOpen ? 'block' : 'none' }}
                                                        >
                                                            {item.a}
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                    </div>
                    <div className={css.bottomCover}>
                        <div className={css.languageCover}>
                            <div className={css.languageTitle}>
                                <FormattedMessage id="FaqPage.cta.title" defaultMessage="Need More Help?" />
                            </div>
                            <div className={css.languageText}>
                                <FormattedMessage id="FaqPage.cta.text" defaultMessage="Our friendly team is available by chat or email to guide you through setup, scheduling, or technical questions. We’re always here to make sure your experience stays smooth are positive." />
                            </div>
                            <div className={css.joinButton}>
                                <a href="/p/live-chat-support">
                                    <FormattedMessage id="FaqPage.cta.join" defaultMessage="Chat With Us" />
                                </a>
                            </div>
                            <div className={css.flipAnimationLeft}>
                                <svg width="96" height="86" viewBox="0 0 96 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M89.2727 31.9133C82.5239 24.2146 72.9932 19.5121 62.7773 18.8404C52.5613 18.1687 42.497 21.5827 34.7982 28.3315C27.0995 35.0803 22.397 44.611 21.7253 54.8269C21.0535 65.0429 24.4676 75.1072 31.2164 82.806L60.2445 57.3597L89.2727 31.9133Z"
                                        fill="#FEC220" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutSingleColumn>
        </Page>
    )
}

export default FaqPage